import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';
import { styles as styleHelpersStyles } from '../../../assets/style-helpers.scss';
import { InputWidthValues } from '../../../ui/gzInput';

export const templateWebAccessControlCustomPagesForm = document.createElement('template');

templateWebAccessControlCustomPagesForm.innerHTML = `
<style>${commonStyles}</style>
<style>${styles}</style>
<style>${styleHelpersStyles}</style>
<div class="wrapper">
    <div class="loading-container">
      <gz-progress-spinner size="large"></gz-progress-spinner>
    </div>

    <gz-image-repo state="error" class="loading-error">
      <gz-text fontSize="14" fontWeight="400" class="loading-error--message" />
    </gz-image-repo>

    <div class="content">
      <gz-title id="pageTitle" class="pb-5 pt-2" fontweight="400" fontsize="20"></gz-title>

      <gz-form-field id="pageNameFieldForm" required>
        <gz-input gz-form-input inputWidth=${InputWidthValues.XLARGE}></gz-input>
      </gz-form-field>

      <gz-form-field class="hidden" id="btnToggleSwitchAllowChange">
        <gz-toggle gz-form-input></gz-toggle>
        <gz-input-error></gz-input-error>
      </gz-form-field>

      <gz-form-field id="logoLinkFieldForm" class="hidden">
        <gz-input gz-form-input inputWidth=${InputWidthValues.XLARGE}></gz-input>
        <gz-input-error></gz-input-error>
      </gz-form-field>

      <gz-title fontsize="12" fontweight="500" class="pb-2 pt-2" id="warningPageTitle"></gz-title>
      <gz-form-field id="warningPageFormField">
        <gz-markdown-editor gz-form-input></gz-markdown-editor>
        <gz-input-error style="line-height: 1; transform: translateY(-40px)"></gz-input-error>
      </gz-form-field>

      <gz-title fontsize="12" fontweight="500" class="pb-2 pt-4" id="blockPageTitle"></gz-title>
      <gz-form-field id="blockPageFormField">
        <gz-markdown-editor gz-form-input></gz-markdown-editor>
        <gz-input-error style="line-height: 1; transform: translateY(-40px)"></gz-input-error>
      </gz-form-field>
   </div>
   <div class="footer">
      <gz-button class="footer--button" id="btnSave"></gz-button>
      <gz-text id="footerMessage" class="hidden" fontWeight="400" fontSize="14" style="line-height:32px"></gz-text>
      <gz-button class="footer--button" id="btnCancel" type="outline" color="secondary"></gz-button>
  </div>
</div>
`;
